<table
  *ngIf="tableOfColumnsReport.tableOfColumnsDetailReport.length || dprTableOfColumns?.comment"
  class="layout-fixed striped"
>
  <colgroup>
    <col class="width-7" />
    <col class="width-{{ tableOfColumnsReport.columnWidth}}" *ngFor="let item of filteredTableOfColumnItems" />
  </colgroup>
  <thead>
    <tr>
      <th [colSpan]="tableOfColumnsReport.columnNumber">
        <h3>{{customName}}</h3>
      </th>
    </tr>
  </thead>
  <ng-container *ngIf="tableOfColumnsReport.tableOfColumnsDetailReport.length">
    <tbody class="secondary-header">
      <tr>
        <td class="text-center">{{StaticMessage.PriorityColumn | staticMessage}}</td>
        <td class="text-center" *ngFor="let projectSetupTableOfColumns of filteredTableOfColumnItems">
          {{projectSetupTableOfColumns.name}}
        </td>
      </tr>
    </tbody>
  </ng-container>
  <tbody *ngFor="let tableOfColumn of tableOfColumnsReport.tableOfColumnsDetailReport; index as tableOfColumnIndex">
    <tr [ngClass]="{'summary-total-row': tableOfColumn.isSummary && isSummaryEnabled}">
      <td class="text-center accent">
        {{tableOfColumn.isSummary && isSummaryEnabled ? summaryLabel : (tableOfColumnIndex + 1)}}
      </td>
      <td
        class="text-center"
        [ngClass]="{'accent': tableOfColumn.isSummary && isSummaryEnabled}"
        *ngFor="let detailItem of tableOfColumn.dprTableOfColumnsDetailItems"
      >
        {{detailItem.value}}
      </td>
    </tr>
  </tbody>
  <tbody class="secondary-header" *ngIf="dprTableOfColumns.comment">
    <tr>
      <td [colSpan]="tableOfColumnsReport.columnNumber">{{StaticMessage.CommentPluralLabel | staticMessage}}</td>
    </tr>
  </tbody>
  <tbody *ngIf="dprTableOfColumns.comment">
    <tr>
      <td
        [colSpan]="tableOfColumnsReport.columnNumber"
        class="white-space-pre-wrap"
        [innerHTML]="(dprTableOfColumns?.comment | trim) || '-'"
      ></td>
    </tr>
  </tbody>
</table>
